<template>
    <component
        :is='selectTag'
        :multiple="true"
        :name="name"
        :class="{'prefixed-dropdown': prefixed, 'postpended-dropdown': postpended}"
        :options="choicesRaw"
        :required="required"
        :disabled="disabled"
        :value="displayValue"
        @input="handleInput($event)"
    />
</template>

<script>
    // Warning! Avoid using ';' and '|' in choices.
    // ';': v-select does not work properly with commas in choices. It breaks
    // words by them. However we need to support them. We replace ',' with ';' and
    // then revert it back. So please make sure that none of the choices contains ';'.
    // '|': we use as a separate for "value" property.
    import VueSelectVirtual from './vue-select-virtual/_vue-select-virtual.vue';

    const EVENTS = {
        INPUT: 'input',
    }

    export default {
        name: 'select-input',
        props: {
            name: {type: String, required: true},
            // Choices format: [choice 1, choice 2, choice 3]
            choices: {type: Array, required: true},
            // Value use '|' as a separator. Example: 'choice 1 | choice 2' corresponds to [choice1, choice2]
            value: {required: true, default: ''},
            required: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            prefixed: {type: Boolean, default: false},
            postpended: {type: Boolean, default: false},
            virtual: {type: Boolean, default: false},  // Use virtual list for large lists of options
        },
        computed: {
            displayValue,
            selectTag: function() {
                return this.virtual ? 'v-select-virtual' : 'v-select'
            },
            choicesRaw: function() {
                return this.choices.map((option) => option.key );
            }
        },
        methods: {
            handleInput,
        },
        components: {
            'v-select-virtual': VueSelectVirtual
        }
    };

    function displayValue() {
        return this.value.split(';').map(el => el.trim()).filter(el => !!el);
    }

    function handleInput(event) {
        this.$emit(EVENTS.INPUT, event.map(el => el).join('; '));
    }

</script>
